import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthProviderWrapper";
import { Spin } from "antd";

const IsAdmin = (props) => {
  const { isLoggedIn, isLoading, isAdmin, userCompanies } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="loading">
        <Spin spinning={true} fullscreen />
      </div>
    );
  } else if (!isLoggedIn) {
    return <Navigate to="/" />;
  } else if (!isAdmin) {
    if (!userCompanies || userCompanies.length === 0) {
      return <Navigate to="/empty" />;
    }
    return <Navigate to="/infoIdentifier" />;
  } else {
    return props.children;
  }
};

export default IsAdmin;
